export default "__VITE_ASSET__CLFfstdF__"